import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './utils/LanguageContext';
import MainNav from './components/navigation/MainNav';
import GuidePage from './pages/GuidePage';
import AboutPage from './pages/AboutPage';
import ModulesPage from './pages/ModulesPage';
import Footer from './components/layout/Footer';
import './styles/index.css';

const router = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

function App() {
  return (
    <LanguageProvider>
      <Router {...router}>
        <div className="min-h-screen flex flex-col">
          <MainNav />
          <main className="flex-grow bg-gray-50">
            <Routes>
              <Route path="/" element={<GuidePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/modules" element={<ModulesPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;